/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 09:51:56 
 * @Last Modified by:   jingyu.yang 
 * @Last Modified time: 2021-12-17 09:51:56 
 */
import { post, getJson} from '.';

export const rollcall = {
  rollcall: data => {
    // 发起点名
    return post(`${config.cpp}handler/v1/rollcall`, data);
  },
  state: data => {
    // 结束点名
    return post(`${config.cpp}handler/v1/rollcall/state`, data);
  },

  answer: data => {
    // 答到
    return post(`${config.cpp}receiver/v1/rollcall/answer`, data);
  },
  list: (data, id) => {
    //只要嘉宾列表传7，5是观众，所有不用传role
    return getJson(`${config.cpp}handler/v1/rollcall/${id}/7`, data);
  }
}

